import React, { useState, useContext, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Store,
  Settings,
  LogOut,
  ArrowRight,
  Clock,
  PlayCircle,
  MonitorCog,
  StopCircle,
  ScanLine,
  UserRound,
  MessageCircle,
} from "lucide-react";
import "../../assets/css/App.css";
import "./header.css";
import {
  appConfigs,
  getAppInfo,
  getInitialRouteForApp,
  getLogoForApp,
  getAppNameForApp,
  getMenuItemsForApp,
  detectAppFromPath,
  isMenuItemAllowed,
  isPathValidForApp,
  getEnhancedInitialRoute,
  getAccessibleMenuItems,
  generateSettingsSubmenu,
} from "./appRoutes";
import trio_dropdown from "../../assets/Image/trio_menu.png";
import AuthContext from "../../utils/secure-route/AuthContext";
import { useChatPanel } from "./Chat/ChatPanelContext";
// import { ToastContainer } from "react-toastify";

import { useToastHandler } from "../common/ToastHandler";
import SubscriptionPage from "../Pages/AppPAges/SubscriptionUI/SubscriptionPage";
import useApi from "../../utils/api-manager/Helper/useApi";
import shopeKeeper from "../../assets/img/shopkeeper.png";
import PaymentPage from "../Pages/AppPAges/SubscriptionUI/PaymentPage";
import { useConfig } from "../../context/ConfigContext";
import axios from "axios";
import config from "../../config/Global.json";
import { useStore } from "../../context/StoreContext";
import { applyCatalogLayout, startsCatalogSection } from "./appCatalogLayout";
import ShiftBar from "./ShiftBar";
import { useShift } from "../Pages/AppPAges/Lottery/ShiftContext";
import LotteryScanModal from "../Pages/AppPAges/Lottery/LotteryScanModal";
import PrintReport from "../Pages/AppPAges/Reports/PrintReport";
import ReactCardFlip from "react-card-flip";
import { AnnouncementDisplay, AppNotificationHub } from "./Announcements";
import useMyPermissions from "../../utils/permissions/useMyPermissions";

const isAppAccessible = (appKey, features) => {
  const app = getAppInfo(appKey);
  if (!app) return false;
  if (appKey === "paisa_vara") return true;
  if (app.feature === null) return true;
  if (Array.isArray(app.feature)) {
    return app.feature.some((f) => features.includes(f));
  }
  return features.includes(app.feature);
};

const Header = ({ onEndShift, onOpenScanModal }) => {
  const { can: canAccessModule, canAccessPage, isConfigured: hasPermissionGroupConfigured } = useMyPermissions();
  const [currentApp, setCurrentApp] = useState(() => {
    const savedApp = localStorage.getItem("currentApp") || "paisa_vara";
    const defaultApp = localStorage.getItem("defaultApp");
    const features = JSON.parse(
      localStorage.getItem("allowedFeatures") || "[]",
    );
    if (defaultApp && isAppAccessible(defaultApp, features)) {
      return defaultApp;
    }
    return savedApp;
  });
  const today = new Date().toISOString().split("T")[0];
  const [isShiftStarting, setIsShiftStarting] = useState(false);
  const [allowedFeatures, setAllowedFeatures] = useState([]);
  const { logOutUser, user, permissions } = useContext(AuthContext);
  const { togglePanel: toggleChatPanel } = useChatPanel() || {};
  const [settingsDropOpen, setsettingsDropOpen] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [, SetUserProfile] = useState("");
  const [, setUserEmail] = useState("");
  const [storename, setStoreName] = useState("");
  const [, setSubscriptionName] = useState("");
  const [isShiftActiveData] = useState(null);
  // const [loadings, setLoading] = useState(false);
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();
  const avatarRef = useRef(null);
  const notificationRef = useRef(null);
  const generalRef = useRef(null);
  const expenseRef = useRef(null);
  const settingsRef = useRef(null);
  const lotteryRef = useRef(null);
  const inventoryRef = useRef(null);
  const gasRef = useRef(null);
  const storeSettingsRef = useRef(null);
  const [activeShift] = useState(null);
  const { Get, Post, clearCache, _Get, getAPI } = useApi();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [appCatalog, setAppCatalog] = useState([]);
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("authToken") || "null");
    axios.get(`${config.api.host}${config.api.featuresWithPrices}`, {
      headers: stored?.access ? { Authorization: `Bearer ${stored.access}` } : {},
    }).then(({ data }) => setAppCatalog(Array.isArray(data) ? data : data?.results || []))
      .catch(() => setAppCatalog([]));
  }, []);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { handleToast } = useToastHandler();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileActiveDropdown, setMobileActiveDropdown] = useState(null);
  const [mobileDockCenter, setMobileDockCenter] = useState(currentApp);
  const [mobileDockFocused, setMobileDockFocused] = useState(false);
  const mobileDockRef = useRef(null);
  const mobileDockIdleRef = useRef(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showingPaymentPage, setShowingPaymentPage] = useState(false);
  const [selectedModulesForPayment, setSelectedModulesForPayment] = useState(
    [],
  );
  const [showScanModal, setShowScanModal] = useState(false);
  const [selectedBillingCycle, setSelectedBillingCycle] = useState("Monthly");
  const [featuresLoaded, setFeaturesLoaded] = useState(false);
  const { setStoreId, setDateFormat, setCurrency } = useConfig();
  const { setManualAuthToken } = useContext(AuthContext);
  const [allShifts] = useState([]);
  const [showLotteryModal, setShowLotteryModal] = useState(false);
  const [scannedTickets, setScannedTickets] = useState([]);
  const headerDisplayName =
    `${firstName || ""} ${lastName || ""}`.trim() ||
    user?.first_name ||
    user?.username ||
    "";
  const headerAvatar = profileImage || shopeKeeper;
  const [greeting, setGreeting] = useState("");
  const [greetingEmoji, setGreetingEmoji] = useState("");
  const [isSettingsDropdownVisible, setIsSettingsDropdownVisible] =
    useState(false);
  const { shiftData, endShift, startShift, loading, checkActiveShift } =
    useShift();
  const shiftId = shiftData?.shift_id;
  const shiftDetails = { shift: shiftData };

  const {
    stores,
    setStores,
    isMultipleStore,
    setIsMultipleStore,
    currentStoreId,
    setCurrentStoreId,
    refreshStores,
    refreshTrigger,
  } = useStore();
  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/");
    }
  }, [location.pathname, navigate]);

  const handleShiftEnd = async () => {
    const result = await endShift();
    if (result.success) {
      await checkActiveShift();
    } else {
      handleToast({
        type: "ERROR",
        message: result.error || "Failed to end shift.",
      });
    }
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isShiftStarting || shiftData?.is_active || shiftData?.shift_id) {
      return;
    }

    setIsShiftStarting(true);

    try {
      console.log("Starting shift...");

      const result = await startShift();

      console.log("Start shift result:", result);

      if (result?.success === false) {
        handleToast({
          type: "ERROR",
          message: result.error || "Failed to start shift",
        });
        return;
      }

      await checkActiveShift();
      setsettingsDropOpen(false);
    } catch (error) {
      console.error("Error starting shift:", error);
      handleToast({
        type: "ERROR",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Error occurred while starting the shift. Please try again.",
      });
    } finally {
      setIsShiftStarting(false);
    }
  };

  const handleConfirm = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    await handleSubmit(e);
  };

  const handleCloseScanModal = () => {
    setShowScanModal(false);
  };

  const handleScanClick = () => {
    if (onOpenScanModal) {
      onOpenScanModal();
    } else {
      setShowScanModal(true);
    }
  };

  const handleScanSuccess = (newTickets) => {
    const ticketsArray = Array.isArray(newTickets) ? newTickets : [newTickets];
    setScannedTickets((prev) => [...prev, ...ticketsArray]);
    setShowScanModal(false);
  };

  useEffect(() => {
    const updateFeaturesFromStorage = () => {
      const updatedFeatures = localStorage.getItem("allowedFeatures");
      if (updatedFeatures) {
        setAllowedFeatures(JSON.parse(updatedFeatures));
      }
      setFeaturesLoaded(true);
    };
    updateFeaturesFromStorage();
    const handleFeaturesUpdated = () => {
      updateFeaturesFromStorage();
    };
    window.addEventListener("allowedFeaturesUpdated", handleFeaturesUpdated);
    return () => {
      window.removeEventListener(
        "allowedFeaturesUpdated",
        handleFeaturesUpdated,
      );
    };
  }, []);

  useEffect(() => {
    if (!featuresLoaded) return;

    const path = location.pathname;
    const detectedApp = detectAppFromPath(path);
    const defaultApp = localStorage.getItem("defaultApp");
    const features = JSON.parse(
      localStorage.getItem("allowedFeatures") || "[]",
    );

    if (
      path === "/" &&
      defaultApp &&
      isAppAccessible(defaultApp, features) &&
      currentApp !== "paisa_vara"
    ) {
      const initialRoute = getInitialRouteForApp(defaultApp);
      navigate(initialRoute);
      setCurrentApp(defaultApp);
      localStorage.setItem("currentApp", defaultApp);
      return;
    }

    if (path === "/" && currentApp === "paisa_vara") {
      return;
    }

    const hasAccessToDetectedApp = isAppAccessible(
      detectedApp,
      allowedFeatures,
    );
    const isValidForCurrentApp = isPathValidForApp(path, currentApp);

    if (!isValidForCurrentApp) {
      if (hasAccessToDetectedApp) {
        setCurrentApp(detectedApp);
        localStorage.setItem("currentApp", detectedApp);
      } else {
        navigate("/");
      }
    }
  }, [
    location.pathname,
    currentApp,
    navigate,
    allowedFeatures,
    featuresLoaded,
  ]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const checkFullscreen = () => {
      // Viewport dimensions can match screen dimensions in responsive/device
      // emulation and on mobile browsers. Only the Fullscreen API is reliable;
      // the old size comparison incorrectly removed the complete header.
      setIsFullscreen(Boolean(document.fullscreenElement));
    };

    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    checkFullscreen();

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    setMobileDockCenter(currentApp);
    const frame = window.requestAnimationFrame(() => {
      const matches = mobileDockRef.current?.querySelectorAll(`[data-app-key="${currentApp}"]`);
      matches?.[Math.floor(matches.length / 2)]?.scrollIntoView({ inline: "center", block: "nearest" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [currentApp]);

  const handleLogout = (e) => {
    logOutUser();
    localStorage.removeItem("currentApp");
  };

  useEffect(() => {
    handleCheckUser();
  }, []);

  const handleCheckUser = async (storeId = null) => {
    try {
      const response = await _Get(
        "checkUserType",
        storeId ? { store_id: storeId } : {},
      );

      const formattedRole = response.role_name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      const timeZone =
        response?.store_configuration?.time_zone || "Asia/Calcutta";
      const currentHour = new Date().toLocaleString("en-US", {
        hour: "numeric",
        hour12: false,
        timeZone: timeZone,
      });

      let greeting = "Hello";
      let emoji = "👋";

      if (currentHour < 12) {
        greeting = "Good Morning";
        emoji = "☀️";
      } else if (currentHour < 17) {
        greeting = "Good Afternoon";
        emoji = "🌤️";
      } else {
        greeting = "Good Evening";
        emoji = "🌙";
      }

      setGreeting(greeting);
      setGreetingEmoji(emoji);

      SetUserProfile(response.results);
      setFirstName(response.first_name || "");
      setLastName(response.last_name || "");
      setUserRole(formattedRole);
      setStoreName(response.store_name);
      setUserEmail(response.store_email);
      setSubscriptionName(response.subscription_plan);
      setIsMultipleStore(response.is_multiple_store);

      if (user?.user_id || user?.id) {
        try {
          const profileResponse = await Get(
            `${getAPI("updateUserProfile")}${user.user_id || user.id}`,
          );
          const imagePath =
            profileResponse?.profile_image ||
            profileResponse?.avatar ||
            profileResponse?.profile_picture ||
            profileResponse?.logo;
          if (imagePath) {
            setProfileImage(
              imagePath.startsWith("http")
                ? imagePath
                : `${getAPI("path")}${imagePath}`,
            );
          }
        } catch (profileError) {
          console.warn("Profile image could not be loaded:", profileError);
        }
      }

      if (response.store_configuration) {
        const currency = response.store_configuration.currency || "USD";
        const dateFormat =
          response.store_configuration.date_format || "MM-DD-YYYY";
        setDateFormat(dateFormat);
        setCurrency(currency);
      }

      if (response.matching_features_titles) {
        const normalizedFeatures = response.matching_features_titles.flatMap(
          (feat) =>
            feat.includes("+") ? feat.split("+").map((f) => f.trim()) : feat,
        );

        setAllowedFeatures(normalizedFeatures);
        localStorage.setItem(
          "allowedFeatures",
          JSON.stringify(normalizedFeatures),
        );

        const event = new Event("allowedFeaturesUpdated");
        window.dispatchEvent(event);
      }

      if (response.role_name === "store owner" && response.is_first_time) {
        setShowSubscriptionModal(true);
      }

      localStorage.setItem("subscriptionActive", "true");

      if (location.pathname === "/" || location.pathname === "/") {
        navigate("/");
      }

      if (location.pathname === "/change-password") {
        return null;
      }
    } catch (error) {
      console.error("Error in handleCheckUser:", error);
    }
  };

  useEffect(() => {
    const handleProfileUpdated = (event) => {
      const updatedProfile = event.detail || {};
      if (updatedProfile.first_name !== undefined) {
        setFirstName(updatedProfile.first_name || "");
      }
      if (updatedProfile.last_name !== undefined) {
        setLastName(updatedProfile.last_name || "");
      }

      const imagePath =
        updatedProfile.profile_image ||
        updatedProfile.avatar ||
        updatedProfile.profile_picture ||
        updatedProfile.logo;
      if (imagePath) {
        setProfileImage(
          imagePath.startsWith("http") || imagePath.startsWith("blob:")
            ? imagePath
            : `${getAPI("path")}${imagePath}`,
        );
      }
    };

    window.addEventListener("paisavara-profile-updated", handleProfileUpdated);
    return () => {
      window.removeEventListener("paisavara-profile-updated", handleProfileUpdated);
    };
  }, [getAPI]);

  const handleStoreManageClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownVisible(!isDropdownVisible);

    if (!isDropdownVisible) {
      refreshStores();
    }
  };

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await Get("getAllStoresOfUser");
        const { first_store, sub_stores } = response;
        const allStores = [first_store, ...(sub_stores || [])];
        setStores(allStores);
        setIsMultipleStore(allStores.length > 1);
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, [refreshTrigger]);

  const handleStoreClick = async (e, storeId) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      const response = await Post("selectStore", { store_id: storeId });
      setCurrentStoreId(response.data.store_id);
      setStoreId(response.data.store_id);
      setDateFormat("MM-DD-YYYY");
      setCurrency("USD");
      setCurrentApp("paisa_vara");
      setCurrentStoreId(storeId);
      localStorage.setItem("currentApp", "paisa_vara");

      const currentAuthToken = JSON.parse(localStorage.getItem("authToken"));
      const refreshToken =
        localStorage.getItem("refresh_token") || currentAuthToken?.refresh;

      if (refreshToken) {
        try {
          const apiUrl = `${config.api.host}${config.api.refreshToken}`;
          const tokenResponse = await axios.post(
            apiUrl,
            { refresh: refreshToken },
            { headers: { "Content-Type": "application/json" } },
          );

          if (tokenResponse.data && tokenResponse.data.access) {
            setManualAuthToken(tokenResponse.data);

            await handleCheckUser(storeId);
          }
        } catch (tokenError) {
          console.error("Token refresh failed:", tokenError);
          logOutUser("Session expired. Please login again.");
          return;
        }
      }

      setDropdownVisible(false);
      setsettingsDropOpen(false);
      handleToast({
        type: "SUCCESS",
        message: "Switching store successfully!",
      });
      navigate(getInitialRouteForApp("paisa_vara"));
    } catch (error) {
      console.error("Error selecting store:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to switch store. Please try again.",
      });
    }
  };

  const handleOwnerClick = (event) => {
    event.preventDefault();
    navigate("/owner-dashboard");
  };

  const handleClickOutside = (event) => {
    const refs = [
      avatarRef,
      notificationRef,
      generalRef,
      expenseRef,
      settingsRef,
      lotteryRef,
      gasRef,
      inventoryRef,
      storeSettingsRef,
      settingsRef,
    ];

    if (
      !refs.some((ref) => ref.current && ref.current.contains(event.target))
    ) {
      setsettingsDropOpen(false);
      setDropdownVisible(false);
      setIsSettingsDropdownVisible(false);
    }

    const mobileMenuEl = document.querySelector(".mobile-menu");
    const mobileMenuBtn = document.querySelector(".mobile-menu-button");
    if (
      isMobileMenuOpen &&
      mobileMenuEl &&
      !mobileMenuEl.contains(event.target) &&
      mobileMenuBtn &&
      !mobileMenuBtn.contains(event.target)
    ) {
      console.log("[MobileMenu] Closed by outside click");
      setIsMobileMenuOpen(false);
      setMobileActiveDropdown(null);
    }
  };

  const closeDropdowns = () => {
    setsettingsDropOpen(false);
    setDropdownVisible(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownElement = document.querySelector(".pv-app-switch-popover");
      const trioDropdownImage = document.querySelector('img[alt="trio"]');

      if (
        showDropdown &&
        dropdownElement &&
        trioDropdownImage &&
        !dropdownElement.contains(event.target) &&
        !trioDropdownImage.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  useEffect(() => {
    const updateFeaturesFromStorage = () => {
      const defaultApp = localStorage.getItem("defaultApp");
      const features = JSON.parse(
        localStorage.getItem("allowedFeatures") || "[]",
      );

      if (defaultApp && isAppAccessible(defaultApp, features)) {
        setCurrentApp(defaultApp);
      }
    };

    const handleDefaultAppUpdated = () => {
      updateFeaturesFromStorage();
    };
    window.addEventListener("defaultAppUpdated", handleDefaultAppUpdated);
    return () => {
      window.removeEventListener("defaultAppUpdated", handleDefaultAppUpdated);
    };
  }, []);

  const isDashboardPath = (path) => {
    const dashboardPaths = {
      paisa_vara: ["/"],
      cheque_pal: ["/cheque-dashboard"],
      pms_app: ["/pms-dashboard"],
      timecard_app: ["/timecard-dashboard"],
      payroll_app: ["/payroll-dashboard"],
      marketing_app: ["/marketing-dashboard"],
      sales_app: ["/quick-Invoice"],
      inventory_app: ["/inventory-dashboard"],
      lottery_app: ["/lottery-dashboard"],
      gas_app: ["/gas-dashboard"],
      pos_app: ["/pos-dashboard"],
      spends_tracking_app: ["/expense"],
      gl_app: ["/ATM"],
      legal_app: ["/legal-dashboard"],
      asset_app: ["/asset-management-dashboard"],
      camera_app: ["/camera/cameras"],
    };

    return dashboardPaths[currentApp]?.includes(path) || false;
  };

  const isMenuItemActive = (item) => {
    const currentPath = location.pathname;

    if (currentPath === "/cheque-preview" && item.name === "Cheque Form") {
      return true;
    }
    if (currentPath === "/subscriptionInvoice" && item.name === "Settings") {
      return true;
    }
    if (
      currentPath.startsWith("/document-preview/") &&
      item.name === "Legal Documents"
    ) {
      return true;
    }
    // if (currentPath === "/lotteryreports" && item.name === "Lottery Reports") {
    //   return true;
    // }

    if (item.path) {
      return currentPath === item.path;
    }

    if (item.submenu) {
      return item.submenu.some((subItem) => currentPath === subItem.path);
    }

    return false;
  };

  const clearAndReload = () => {
    clearCache("all");
  };

  const handleMobileMenuItemClick = (itemName) => {
    if (mobileActiveDropdown === itemName) {
      setMobileActiveDropdown(null);
    } else {
      setMobileActiveDropdown(itemName);
    }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setMobileActiveDropdown(null);
  };

  const checkPermission = (permissionCode) => {
    if (!permissions || !permissionCode) return true;

    if (permissions.includes("all")) {
      return true;
    }
    return permissions.includes(permissionCode);
  };

  const handleAppSwitch = (appType) => {
    if (!isAppAccessible(appType, allowedFeatures)) {
      handleToast({
        type: "ERROR",
        message: "You don't have access to this application",
      });
      return;
    }

    setCurrentApp(appType);
    localStorage.setItem("currentApp", appType);
    setShowDropdown(false);
    setActiveDropdown(null);

    window.dispatchEvent(
      new CustomEvent("appSwitched", {
        detail: {
          appKey: appType,
        },
      }),
    );

    const targetRoute = getEnhancedInitialRoute(
      appType,
      allowedFeatures,
      permissions,
      userRole,
    );

    navigate(targetRoute);
  };

  useEffect(() => {
    const handleAppSwitched = (event) => {
      const { appKey } = event.detail || {};
      if (appKey) {
        setCurrentApp(appKey);
        localStorage.setItem("currentApp", appKey);
        setActiveDropdown(null);
      }
    };

    window.addEventListener("appSwitched", handleAppSwitched);

    return () => {
      window.removeEventListener("appSwitched", handleAppSwitched);
    };
  }, []);

  useEffect(() => {
    if (!featuresLoaded) return;

    const path = location.pathname;
    const detectedApp = detectAppFromPath(path);
    const defaultApp = localStorage.getItem("defaultApp");
    const features = JSON.parse(
      localStorage.getItem("allowedFeatures") || "[]",
    );

    if (
      path === "/" &&
      defaultApp &&
      isAppAccessible(defaultApp, features) &&
      currentApp !== "paisa_vara"
    ) {
      const initialRoute = getEnhancedInitialRoute(
        defaultApp,
        allowedFeatures,
        permissions,
        userRole,
      );
      navigate(initialRoute);
      setCurrentApp(defaultApp);
      localStorage.setItem("currentApp", defaultApp);
      return;
    }

    if (path === "/" && currentApp === "paisa_vara") {
      return;
    }

    const hasAccessToDetectedApp = isAppAccessible(
      detectedApp,
      allowedFeatures,
    );
    const isValidForCurrentApp = isPathValidForApp(path, currentApp);

    if (!isValidForCurrentApp) {
      if (hasAccessToDetectedApp) {
        setCurrentApp(detectedApp);
        localStorage.setItem("currentApp", detectedApp);
      } else {
        navigate("/");
      }
    }
  }, [
    location.pathname,
    currentApp,
    navigate,
    allowedFeatures,
    featuresLoaded,
    permissions,
    userRole,
  ]);

  const [mobileSettingsOpen, setMobileSettingsOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(null);
  const [moreSubOpen, setMoreSubOpen] = useState(null);
  const navRef = useRef(null);

  useEffect(() => {
    const calculateVisibleCount = () => {
      if (!navRef.current) return;
      const navWidth = navRef.current.offsetWidth;
      const accessibleItems = getAccessibleMenuItems(
        currentApp,
        allowedFeatures,
        permissions,
        userRole,
        { isConfigured: hasPermissionGroupConfigured, canAccessPage },
      );
      if (accessibleItems.length === 0) return;
      // Estimate avg item width (nav font ~13px, avg 10 chars + padding)
      const avgItemWidth = 110;
      const moreWidth = 70;
      const maxFit = Math.floor((navWidth - moreWidth) / avgItemWidth);
      setVisibleCount(Math.max(1, maxFit));
    };
    calculateVisibleCount();
    window.addEventListener("resize", calculateVisibleCount);
    return () => window.removeEventListener("resize", calculateVisibleCount);
  }, [currentApp, allowedFeatures, permissions, userRole, hasPermissionGroupConfigured, canAccessPage]);

  const renderMenuItems = () => {
    const accessibleItems = getAccessibleMenuItems(
      currentApp,
      allowedFeatures,
      permissions,
      userRole,
      { isConfigured: hasPermissionGroupConfigured, canAccessPage },
    );

    // Use measured count; if not yet measured or all fit, show all
    const limit = visibleCount !== null ? visibleCount : accessibleItems.length;
    const needsMore = accessibleItems.length > limit;
    const visibleItems = needsMore
      ? accessibleItems.slice(0, limit)
      : accessibleItems;
    const overflowItems = needsMore ? accessibleItems.slice(limit) : [];

    const renderItem = (item, index) => {
      const isActive = isMenuItemActive(item);
      if (item.submenu) {
        return (
          <li
            key={index}
            className={`nav-item ${isActive ? "active" : ""} ${activeDropdown === item.name ? "dropdown-active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveDropdown(
                activeDropdown === item.name ? null : item.name,
              );
            }}
          >
            <a
              href="#"
              className="nav-link"
              onClick={(e) => e.preventDefault()}
            >
              {item.name}
            </a>
            {activeDropdown === item.name && (
              <ul className="nav-menu-drop">
                {item.submenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link
                      className={`nav-menu-drop-item ${location.pathname === subItem.path ? "active" : ""}`}
                      to={subItem.path}
                      onClick={() => setActiveDropdown(null)}
                    >
                      {subItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        );
      }
      return (
        <li key={index} className={`nav-item ${isActive ? "active" : ""}`}>
          <Link
            className="nav-link"
            to={item.path}
            onClick={() => setActiveDropdown(null)}
          >
            {item.name}
          </Link>
        </li>
      );
    };

    return (
      <>
        {visibleItems.map((item, index) => renderItem(item, index))}
        {overflowItems.length > 0 && (
          <li
            className={`nav-item more-nav-item ${
              overflowItems.some((item) => isMenuItemActive(item))
                ? "more-has-active"
                : ""
            } ${activeDropdown === "__more__" ? "dropdown-active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveDropdown(
                activeDropdown === "__more__" ? null : "__more__",
              );
              setMoreSubOpen(null);
            }}
          >
            <a
              href="#"
              className="nav-link more-link"
              onClick={(e) => e.preventDefault()}
            >
              More »
            </a>
            {activeDropdown === "__more__" && (
              <ul className="nav-menu-drop nav-more-drop">
                {overflowItems.map((item, idx) => {
                  const isActive = isMenuItemActive(item);
                  if (item.submenu) {
                    return (
                      <li
                        key={idx}
                        className="more-drop-item-wrapper"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMoreSubOpen(
                            moreSubOpen === item.name ? null : item.name,
                          );
                        }}
                      >
                        <span
                          className={`nav-menu-drop-item more-parent ${isActive ? "active" : ""}`}
                        >
                          {item.name} <span className="more-arrow">»</span>
                        </span>
                        {moreSubOpen === item.name && (
                          <ul className="nav-menu-drop nav-more-sub">
                            {item.submenu.map((subItem, subIndex) => (
                              <li key={subIndex}>
                                <Link
                                  className={`nav-menu-drop-item ${location.pathname === subItem.path ? "active" : ""}`}
                                  to={subItem.path}
                                  onClick={() => {
                                    setActiveDropdown(null);
                                    setMoreSubOpen(null);
                                  }}
                                >
                                  {subItem.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  }
                  return (
                    <li key={idx}>
                      <Link
                        className={`nav-menu-drop-item ${isActive ? "active" : ""}`}
                        to={item.path}
                        onClick={() => {
                          setActiveDropdown(null);
                          setMoreSubOpen(null);
                        }}
                      >
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        )}
      </>
    );
  };
  const handleSettingsClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSettingsDropdownVisible(!isSettingsDropdownVisible);
  };
  const renderSettingsDropdown = () => {
    const canSwitchStore =
      (userRole === "Store Owner" || userRole === "Store Manager") &&
      isMultipleStore;
    return (
      <div className="profile-container" onClick={(e) => e.stopPropagation()}>
        <div className="profile-card" onClick={(e) => e.stopPropagation()}>
          {}
          <div className="profile-header">
            {isShiftActiveData?.is_active && (
              <div className="shift-badges">
                <Clock size={16} />
                <span className="shift-name">
                  {isShiftActiveData.current_shift}
                </span>
                <span className="active-indicator">Active</span>
              </div>
            )}
          </div>

          {}
          <div className="store-info">
            {storename && (
              <div className="info-item">
                <Store size={28} />{" "}
                {/* <img src={store} height="40px" />{" "} */}
                <span className="info-text">{storename}</span>
              </div>
            )}
          </div>

          <div className="shift-control" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className={`shift-button ${
                shiftData?.shift_id || shiftData?.is_active
                  ? "active"
                  : "inactive"
              }`}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (isShiftStarting) return;

                if (shiftData?.shift_id || shiftData?.is_active) {
                  await handleShiftEnd();
                } else {
                  await handleConfirm(e);
                }
              }}
              disabled={isShiftStarting}
              style={{
                background: isShiftStarting
                  ? "#ccc"
                  : shiftData?.shift_id || shiftData?.is_active
                    ? "red"
                    : "linear-gradient(135deg, #4caf50, #45a049)",
                color: "#fff",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                cursor: isShiftStarting ? "not-allowed" : "pointer",
                minWidth: "140px",
              }}
            >
              {isShiftStarting ? (
                "Starting Shift..."
              ) : shiftData?.shift_id || shiftData?.is_active ? (
                <>
                  <StopCircle size={20} />
                  End Shift
                </>
              ) : (
                <>
                  <PlayCircle size={20} />
                  Start Shift
                </>
              )}
            </button>
          </div>
          {}
          <div className="menu-options">
            {}
            {canSwitchStore && (
              <div className="dropdown-wrapper">
                <button
                  className="menu-option"
                  onClick={handleStoreManageClick}
                  aria-expanded={isDropdownVisible}
                  aria-haspopup="true"
                >
                  <Store size={20} />
                  <span>Switch to another store</span>
                  <ArrowRight size={16} />
                </button>
              </div>
            )}

            {}
            <div className="dropdown-wrapper">
              <button
                className="menu-option"
                onClick={handleSettingsClick}
                aria-expanded={isSettingsDropdownVisible}
                aria-haspopup="true"
              >
                <MonitorCog size={20} />
                <span>Store Settings</span>
                <ArrowRight
                  size={16}
                  className={`arrow ${
                    isSettingsDropdownVisible ? "rotated" : ""
                  }`}
                />
              </button>

              {isSettingsDropdownVisible && (
                <div className="dropdown-modal">
                  {generateSettingsSubmenu(allowedFeatures, userRole).map(
                    (setting, index) => (
                      <Link
                        key={index}
                        className="dropdown-item"
                        to={setting.path}
                        onClick={() => setIsSettingsDropdownVisible(false)}
                      >
                        {setting.name}
                      </Link>
                    ),
                  )}
                </div>
              )}
            </div>

            {}
            <Link
              to="/my-profile"
              className="menu-option"
              style={{ textDecorationLine: "none" }}
              onClick={() => setIsSettingsDropdownVisible(false)}
            >
              <UserRound size={20} />
              <span>My Profile</span>
              <ArrowRight size={16} />
            </Link>

            {}
            <Link
              to="/change-password"
              className="menu-option"
              style={{ textDecorationLine: "none" }}
            >
              <Settings size={20} />
              <span>Change Password</span>
              <ArrowRight size={16} />
            </Link>

            <button
              onClick={handleScanClick}
              className="menu-option"
              // style={{
              //   backgroundColor: "#fff",
              //   color: "#0066cc",
              //   border: "none",
              //   padding: "8px 16px",
              //   borderRadius: "4px",
              //   cursor: "pointer",
              //   fontWeight: "bold",
              //   height: "40px"
              // }}
            >
              <ScanLine size={20} />
              <span>Scan Game</span>
              <ArrowRight size={16} />
            </button>

            {}
            {toggleChatPanel && (
              <button
                onClick={toggleChatPanel}
                className="menu-option"
              >
                <MessageCircle size={20} />
                <span>Chat To Team</span>
                <ArrowRight size={16} />
              </button>
            )}
            <PrintReport
              shiftId={shiftId || shiftData?.shift_id}
              today={today}
            />
          </div>

          {}
          <div className="action-buttons">
            <button className="action-btn primary" onClick={handleLogout}>
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  };

  const getSwitchableApps = () => {
    const allowedCodes = permissions || [];
    return applyCatalogLayout(Object.values(appConfigs).filter((app) => {
      const hasFeatureAccess =
        app.feature === null ||
        (Array.isArray(app.feature)
          ? app.feature.some((f) => allowedFeatures.includes(f))
          : allowedFeatures.includes(app.feature));

      // Once a member has been placed in a Permission Group, that group is
      // meant to be the single source of truth for which apps they can open
      // - not an extra restriction layered on top of the old PERM_* codes.
      // Those legacy codes are often stale (e.g. left over from role
      // defaults) and ANDing them in here would either block an app the
      // group explicitly granted, or leak an app the group never granted
      // just because an old code happened to allow it. So: once configured,
      // skip the legacy code check entirely for apps that map to a module;
      // apps with no module mapping still fall back to the legacy check.
      const skipLegacyCodeCheck = hasPermissionGroupConfigured && !!app.permissionModule;

      const hasCodePermission =
        skipLegacyCodeCheck ||
        !app.code ||
        allowedCodes.includes("all") ||
        allowedCodes.includes(app.code);

      // Permission Group check (new system): if this app maps to a module
      // and the current user's membership has been put in a Permission
      // Group, only show the app if that group grants at least view access.
      // Unconfigured memberships (legacy accounts, or accounts nobody has
      // restricted yet) fall through as allowed - see useMyPermissions.
      const hasGroupPermission =
        !app.permissionModule || canAccessModule(app.permissionModule, "view");

      return hasFeatureAccess && hasCodePermission && hasGroupPermission;
    }), appCatalog);
  };

  const updateDockCenter = () => {
    const dock = mobileDockRef.current;
    if (!dock) return;
    const segment = dock.scrollWidth / 3;
    if (dock.scrollLeft < segment * 0.65) dock.scrollLeft += segment;
    else if (dock.scrollLeft > segment * 1.65) dock.scrollLeft -= segment;
    const center = dock.getBoundingClientRect().left + dock.clientWidth / 2;
    const items = [...dock.querySelectorAll('[data-app-key]')];
    const nearest = items.reduce((best, item) => Math.abs(item.getBoundingClientRect().left + item.offsetWidth / 2 - center) < Math.abs(best.getBoundingClientRect().left + best.offsetWidth / 2 - center) ? item : best, items[0]);
    if (nearest?.dataset.appKey) setMobileDockCenter(nearest.dataset.appKey);
  };

  const focusMobileDock = () => {
    setMobileDockFocused(true);
    window.clearTimeout(mobileDockIdleRef.current);
    mobileDockIdleRef.current = window.setTimeout(() => setMobileDockFocused(false), 1800);
  };

  const renderStoreSwitchModal = () => {
    const modalContent = (
      <div
        className="pv-app-switch-backdrop"
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            setDropdownVisible(false);
          }
        }}
      >
        <div
          className="pv-app-switch-popover pv-store-switch-popover"
          onMouseDown={(event) => event.stopPropagation()}
        >
          <div className="pv-app-switch-head">
            <div>
              <span className="pv-app-switch-kicker">Stores</span>
              <h3>Switch Store</h3>
              <p>Select the store you want to switch to.</p>
            </div>

            <div className="pv-app-switch-head-actions">
              <span className="pv-app-switch-count">
                {stores.length} Store{stores.length === 1 ? "" : "s"}
              </span>
              <button
                type="button"
                className="pv-app-switch-close"
                onClick={() => setDropdownVisible(false)}
                aria-label="Close switch store"
              >
                ×
              </button>
            </div>
          </div>

          <div className="pv-store-switch-list">
            {loading ? (
              <div className="pv-store-switch-item loading">Loading...</div>
            ) : stores.length === 0 ? (
              <div className="pv-store-switch-item empty">No other stores found.</div>
            ) : (
              stores.map((store) => (
                <button
                  key={store.id}
                  type="button"
                  className={`pv-store-switch-item ${
                    String(store.id) === String(currentStoreId) ? "active" : ""
                  }`}
                  onClick={(e) => handleStoreClick(e, store.id)}
                >
                  <span className="pv-store-switch-icon">
                    <Store size={18} />
                  </span>
                  <span className="pv-store-switch-name">{store.name}</span>
                  {String(store.id) === String(currentStoreId) && (
                    <span className="pv-app-active-dot" />
                  )}
                </button>
              ))
            )}
          </div>
        </div>
      </div>
    );
    return createPortal(modalContent, document.body);
  };

  const renderAppDropdown = () => {
    const filteredApps = getSwitchableApps();

    const modalContent = (
      <div
        className="pv-app-switch-backdrop"
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            setShowDropdown(false);
          }
        }}
      >
        <div
          className="pv-app-switch-popover"
          onMouseDown={(event) => event.stopPropagation()}
        >
          <div className="pv-app-switch-head">
            <div>
              <span className="pv-app-switch-kicker">Workspace</span>
              <h3>Switch App</h3>
              <p>Select the business app you want to open.</p>
            </div>

            <div className="pv-app-switch-head-actions">
              <span className="pv-app-switch-count">
                {filteredApps.length} Apps
              </span>
              <button
                type="button"
                className="pv-app-switch-close"
                onClick={() => setShowDropdown(false)}
                aria-label="Close switch app"
              >
                ×
              </button>
            </div>
          </div>

          <div className="pv-app-switch-grid app-dropdown">
            {filteredApps.map((app, appIndex) => {
              const isActiveApp = currentApp === app.key;

              return <React.Fragment key={app.key}>
                {startsCatalogSection(filteredApps, appIndex) && <div className="pv-app-switch-section">{app.catalogSection}</div>}
                <button
                  type="button"
                  className={`pv-app-switch-card app-dropdown-item ${
                    isActiveApp ? "active" : ""
                  }`}
                  onClick={() => handleAppSwitch(app.key)}
                  title={app.displayName}
                >
                  <span className="pv-app-switch-icon">
                    <img src={app.logo} alt={app.name} />
                  </span>
                  <span className="pv-app-switch-name">{app.displayName}</span>
                  {isActiveApp && <span className="pv-app-active-dot" />}
                </button>
              </React.Fragment>;
            })}
          </div>
        </div>
      </div>
    );

    return createPortal(modalContent, document.body);
  };

  if (isFullscreen) {
    return null;
  }
  return (
    <>
      <style>{appSwitchDropdownStyles}</style>
      <header className="header-container">
        {/* <ToastContainer /> */}
        <div className="navbar-left">
          <div className="app-switch-container">
            <img
              src={getLogoForApp(currentApp)}
              alt="Logo"
              className="responsive-logo"
            />
            <AppNotificationHub
              storeId={currentStoreId || user.store}
              appKey={currentApp}
              appTitle={getAppNameForApp(currentApp)}
            />
            <img
              src={trio_dropdown}
              alt="trio"
              className="responsive-menu-icon"
              onClick={() => setShowDropdown(!showDropdown)}
            />
            {showDropdown && renderAppDropdown()}
            {isDropdownVisible && renderStoreSwitchModal()}
          </div>

          <button
            className="mobile-menu-button"
            type="button"
            aria-label="Toggle mobile menu"
            onClick={() => {
              console.log(
                "[MobileMenu] Hamburger clicked. isMobileMenuOpen:",
                isMobileMenuOpen,
                "-> will set to:",
                !isMobileMenuOpen,
              );
              console.log("[MobileMenu] Window width:", window.innerWidth);
              setIsMobileMenuOpen(!isMobileMenuOpen);
              setMobileActiveDropdown(null);
            }}
          >
            <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`} />
          </button>
        </div>

        <nav className="navbar navbar-expand-lg desktop-menu">
          <div className="container-fluid">
            <div className="navbar-collapse">
              <ul className="navbar-nav" ref={navRef}>
                {renderMenuItems()}
              </ul>
            </div>
          </div>
        </nav>
        {/* <div
          className="navbar-right"
          onClick={(e) => {
            e.stopPropagation();
            setsettingsDropOpen(!settingsDropOpen);
          }}
        >
        {shiftData && shiftData.is_active ? (
  <>
    <div className="user-infos user-mode shift-user-mode" ref={avatarRef}>
      <ShiftBar
        shiftId={shiftData?.shift_id}
        shiftTitle={shiftData.title}
        onEndShift={handleShiftEnd}
        shiftStartAt={shiftData.shift_start_at || null}
        loading={loading}
        shifts={allShifts}
        user={user}
        onOpenScanModal={() => setShowLotteryModal(true)}
      />

      {settingsDropOpen && (
        <div className="settings-dropdown" ref={settingsRef}>
          {renderSettingsDropdown()}
        </div>
      )}
    </div>

    <LotteryScanModal
      show={showLotteryModal}
      onClose={() => setShowLotteryModal(false)}
      shiftDetails={{ shift: shiftData }}
      shiftId={shiftData?.shift_id}
      onScanSuccess={() => setShowLotteryModal(false)}
      scannedTickets={scannedTickets}
    />
  </>
) : (
            <>
              <div className="user-infos user-mode" ref={avatarRef}>
                <div className="user-content">
                  <img src={headerAvatar} className="avatar responsive-avatar" alt="User Avatar" />

                  <div className="user-names-wrapper">
                    <div className="user-names">
                      <div className="user-fullname">
                        {headerDisplayName && <span className="greeting-text">Hey, </span>}
                        {headerDisplayName && <span className="user-name">{headerDisplayName}</span>}
                      </div>
                      <div className="user-greeting">
                        {greeting}{" "}
                        <span className="emoji">{greetingEmoji}</span>
                      </div>
                    </div>
                  </div>

                  <div className="settings-icon">
                    <Settings className="responsive-settings" size={35} />
                  </div>
                </div>

                {settingsDropOpen && (
                  <div className="settings-dropdown" ref={settingsRef}>
                    {renderSettingsDropdown()}
                  </div>
                )}
              </div>
            </>
          )}
        </div> */}
        <div
          className={`navbar-right header-profile-anchor ${
            shiftData?.is_active ? "header-shift-active" : ""
          }`}
        >
          <div
            className="header-profile-click-area"
            ref={avatarRef}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setsettingsDropOpen((prev) => !prev);
            }}
          >
            <ReactCardFlip
              isFlipped={!!(shiftData && shiftData.is_active)}
              flipDirection="horizontal"
              flipSpeedBackToFront={0.6}
              flipSpeedFrontToBack={0.6}
              containerClassName="header-profile-flip-container"
            >
              {/* Normal Profile Mode */}
              <div key="normal-profile" className="header-profile-flip-face">
                <div className="user-infos user-mode">
                  <div className="user-content">
                    <img
                      src={headerAvatar}
                      className="avatar responsive-avatar"
                      alt="User Avatar"
                    />

                    <div className="user-names-wrapper">
                      <div className="user-names">
                        <div className="user-fullname">
                          {headerDisplayName && (
                            <span className="greeting-text">Hey, </span>
                          )}
                          {headerDisplayName && (
                            <span className="user-name">
                              {headerDisplayName}
                            </span>
                          )}
                        </div>

                        <div className="user-greeting">
                          {greeting}{" "}
                          <span className="emoji">{greetingEmoji}</span>
                        </div>
                      </div>
                    </div>

                    <div className="settings-icon">
                      <Settings className="responsive-settings" size={35} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Shift Mode */}
              <div key="shift-profile" className="header-profile-flip-face">
                <div className="user-infos user-mode shift-user-mode">
                  <ShiftBar
                    shiftId={shiftData?.shift_id}
                    shiftTitle={shiftData?.title}
                    onEndShift={handleShiftEnd}
                    shiftStartAt={shiftData?.shift_start_at || null}
                    loading={loading}
                    shifts={allShifts}
                    user={user}
                    onOpenScanModal={() => setShowLotteryModal(true)}
                  />
                </div>
              </div>
            </ReactCardFlip>
          </div>

          {settingsDropOpen && (
            <div
              className="settings-dropdown header-settings-dropdown-fixed"
              ref={settingsRef}
              onClick={(e) => e.stopPropagation()}
            >
              {renderSettingsDropdown()}
            </div>
          )}

          <LotteryScanModal
            show={showLotteryModal}
            onClose={() => setShowLotteryModal(false)}
            shiftDetails={{ shift: shiftData }}
            shiftId={shiftData?.shift_id}
            onScanSuccess={() => setShowLotteryModal(false)}
            scannedTickets={scannedTickets}
          />
        </div>
        {showSubscriptionModal && (
          <div className="subscription-modal-overlay">
            <div className="subscription-modal-content">
              <div>
                {!showingPaymentPage ? (
                  <SubscriptionPage
                    inModal={true}
                    onProceedToPayment={(selectedModules, billingCycle) => {
                      setSelectedModulesForPayment(selectedModules);
                      setSelectedBillingCycle(billingCycle);
                      setShowingPaymentPage(true);
                    }}
                    storeId={currentStoreId || user.store}
                  />
                ) : (
                  <PaymentPage
                    inModal={true}
                    selectedModules={selectedModulesForPayment}
                    billingCycle={selectedBillingCycle}
                    storeId={currentStoreId || user.store}
                    onBack={() => setShowingPaymentPage(false)}
                    onComplete={() => {
                      setShowSubscriptionModal(false);
                      setShowingPaymentPage(false);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </header>
      <AnnouncementDisplay storeId={currentStoreId || user.store} appKey={currentApp} />

      <nav className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
        <div className="mobile-drawer-titlebar"><div><span>Navigation</span><strong>{getAppNameForApp(currentApp)}</strong></div><button type="button" onClick={closeMobileMenu} aria-label="Close navigation drawer">×</button></div>
        <div className="mobile-menu-header">
          <div className="mobile-user-info">
            <img src={headerAvatar} alt="User" className="mobile-user-avatar" />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold" }}>
                {headerDisplayName || "My Profile"}
              </div>
              <div style={{ fontSize: "0.8em", color: "#666" }}>{userRole}</div>
            </div>
            <button className="mobile-settings-toggle" type="button" onClick={() => setMobileSettingsOpen(!mobileSettingsOpen)} aria-label="Open profile settings"><Settings size={18} /></button>
          </div>
        </div>
        {mobileSettingsOpen && (
          <div
            className="mobile-profile-panel"
            onClick={(e) => e.stopPropagation()}
          >
            {renderSettingsDropdown()}
          </div>
        )}

        <ul className="mobile-menu-items">
          {getMenuItemsForApp(currentApp).map((item, index) => {
            if (!isMenuItemAllowed(item.name, allowedFeatures, currentApp)) {
              return null;
            }

            if (item.access.includes("all") || item.access.includes(userRole)) {
              return (
                <li key={index} style={{ borderBottom: "1px solid #eee" }}>
                  {item.submenu ? (
                    <div>
                      <button
                        onClick={() => handleMobileMenuItemClick(item.name)}
                        style={{
                          width: "100%",
                          padding: "15px 20px",
                          textAlign: "left",
                          background: "none",
                          border: "none",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {item.name}
                        <i
                          className={`fas fa-chevron-${
                            mobileActiveDropdown === item.name ? "up" : "down"
                          }`}
                        />
                      </button>
                      {mobileActiveDropdown === item.name && (
                        <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            background: "#f5f5f5",
                          }}
                        >
                          {item.submenu
                            .map((subItem, subIndex) => {
                              const hasAccess =
                                !subItem.access ||
                                subItem.access.includes("all") ||
                                subItem.access.includes(userRole);

                              if (!hasAccess) {
                                return null;
                              }

                              return (
                                <li key={subIndex}>
                                  <Link
                                    to={subItem.path}
                                    onClick={closeMobileMenu}
                                    style={{
                                      display: "block",
                                      padding: "12px 30px",
                                      color: "#333",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {subItem.name}
                                  </Link>
                                </li>
                              );
                            })
                            .filter(Boolean)}{" "}
                          {}
                        </ul>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.path}
                      onClick={closeMobileMenu}
                      style={{
                        display: "block",
                        padding: "15px 20px",
                        color: "#333",
                        textDecoration: "none",
                      }}
                    >
                      {item.name}
                    </Link>
                  )}
                </li>
              );
            }
            return null;
          })}
        </ul>

        <div className="mobile-menu-footer" />
      </nav>

      <div
        className={`mobile-menu-overlay ${isMobileMenuOpen ? "active" : ""}`}
        onClick={closeMobileMenu}
      />

      <div className={`mobile-app-dock-shell ${mobileDockFocused ? 'focused' : 'idle'}`} aria-label="Switch application" onPointerEnter={focusMobileDock} onPointerDown={focusMobileDock} onFocusCapture={focusMobileDock}>
        <div className="mobile-app-dock" ref={mobileDockRef} onScroll={() => { focusMobileDock(); updateDockCenter(); }}>
          {[...getSwitchableApps(), ...getSwitchableApps(), ...getSwitchableApps()].map((app, copyIndex) => {
            const centered = mobileDockCenter === app.key;
            const active = currentApp === app.key;
            return <button type="button" data-app-key={app.key} key={`${app.key}-${copyIndex}`} className={`mobile-dock-app ${centered ? 'centered' : ''} ${active ? 'active' : ''}`} onClick={event => { focusMobileDock(); event.currentTarget.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); setMobileDockCenter(app.key); window.setTimeout(() => handleAppSwitch(app.key), 180); }}><img src={app.logo} alt="" /><span>{app.displayName}</span></button>;
          })}
        </div>
      </div>

      {!onOpenScanModal && (
        <LotteryScanModal
          show={showScanModal}
          onClose={handleCloseScanModal}
          shiftDetails={shiftDetails}
          shiftId={shiftId || shiftData?.shift_id}
          onScanSuccess={handleScanSuccess}
          scannedTickets={scannedTickets}
        />
      )}
    </>
  );
};


const appSwitchDropdownStyles = `
  body:has(.pv-app-switch-backdrop) {
    overflow: hidden;
  }

  .pv-app-switch-backdrop {
    position: fixed !important;
    inset: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    z-index: 2147483000 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 24px !important;
    margin: 0 !important;
    background:
      radial-gradient(circle at top left, rgba(13, 83, 47, 0.10), transparent 32%),
      rgba(15, 23, 42, 0.40) !important;
    backdrop-filter: blur(7px) !important;
    -webkit-backdrop-filter: blur(7px) !important;
    box-sizing: border-box !important;
    animation: pvSwitchBackdropIn 0.16s ease-out;
  }

  .pv-app-switch-popover {
    position: relative !important;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    bottom: auto !important;
    transform: none !important;
    width: min(760px, calc(100vw - 48px)) !important;
    max-width: min(760px, calc(100vw - 48px)) !important;
    max-height: min(680px, calc(100vh - 70px)) !important;
    padding: 18px !important;
    border-radius: 24px !important;
    background:
      radial-gradient(circle at top right, rgba(13, 83, 47, 0.08), transparent 34%),
      #ffffff !important;
    border: 1px solid rgba(226, 232, 240, 0.98) !important;
    box-shadow:
      0 34px 92px rgba(15, 23, 42, 0.30),
      0 10px 26px rgba(15, 23, 42, 0.14) !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    animation: pvSwitchModalIn 0.18s ease-out;
  }

  .pv-app-switch-head {
    display: flex !important;
    align-items: flex-start !important;
    justify-content: space-between !important;
    gap: 14px !important;
    padding: 6px 6px 16px !important;
    border-bottom: 1px solid #eef2f7 !important;
    margin-bottom: 16px !important;
  }

  .pv-app-switch-kicker {
    display: inline-flex !important;
    align-items: center !important;
    height: 23px !important;
    padding: 0 10px !important;
    border-radius: 999px !important;
    color: #0d532f !important;
    background: #ecfdf5 !important;
    border: 1px solid #a7f3d0 !important;
    font-size: 10px !important;
    font-weight: 950 !important;
    letter-spacing: 0.055em !important;
    text-transform: uppercase !important;
    margin-bottom: 8px !important;
  }

  .pv-app-switch-head h3 {
    margin: 0 !important;
    color: #0f172a !important;
    font-size: 22px !important;
    line-height: 1.05 !important;
    font-weight: 950 !important;
    letter-spacing: -0.045em !important;
  }

  .pv-app-switch-head p {
    margin: 5px 0 0 !important;
    color: #64748b !important;
    font-size: 12px !important;
    font-weight: 750 !important;
  }

  .pv-app-switch-head-actions {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    flex-shrink: 0 !important;
  }

  .pv-app-switch-count {
    display: inline-flex !important;
    align-items: center !important;
    height: 30px !important;
    padding: 0 11px !important;
    border-radius: 999px !important;
    color: #475569 !important;
    background: #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
    font-size: 11px !important;
    font-weight: 900 !important;
    white-space: nowrap !important;
  }

  .pv-app-switch-close {
    width: 34px !important;
    height: 34px !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 11px !important;
    background: #ffffff !important;
    color: #475569 !important;
    font-size: 24px !important;
    line-height: 1 !important;
    font-weight: 750 !important;
    cursor: pointer !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: background 0.16s ease, color 0.16s ease, transform 0.16s ease !important;
  }

  .pv-app-switch-close:hover {
    background: #fef2f2 !important;
    color: #dc2626 !important;
    transform: translateY(-1px) !important;
  }

  .pv-app-switch-grid {
    display: grid !important;
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 12px !important;
    max-height: min(500px, calc(100vh - 220px)) !important;
    overflow-y: auto !important;
    padding: 2px 4px 4px 2px !important;
    scrollbar-width: thin !important;
  }

  .pv-app-switch-section {
    grid-column: 1 / -1 !important;
    color: #64748b !important;
    font-size: 11px !important;
    font-weight: 950 !important;
    letter-spacing: .08em !important;
    text-transform: uppercase !important;
    padding: 8px 2px 0 !important;
  }

  .pv-app-switch-grid::-webkit-scrollbar {
    width: 7px;
  }

  .pv-app-switch-grid::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #cbd5e1;
  }

  .pv-app-switch-card {
    position: relative !important;
    min-width: 0 !important;
    min-height: 112px !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 16px !important;
    background:
      linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 10px !important;
    padding: 14px 10px !important;
    cursor: pointer !important;
    text-align: center !important;
    transition:
      transform 0.16s ease,
      box-shadow 0.16s ease,
      border-color 0.16s ease,
      background 0.16s ease !important;
  }

  .pv-app-switch-card:hover {
    transform: translateY(-2px) !important;
    border-color: #0d532f !important;
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12) !important;
    background: #ffffff !important;
  }

  .pv-app-switch-card.active {
    border-color: #0d532f !important;
    background:
      radial-gradient(circle at top, rgba(13, 83, 47, 0.10), transparent 55%),
      #ffffff !important;
    box-shadow: 0 12px 26px rgba(13, 83, 47, 0.12) !important;
  }

  .pv-app-switch-icon {
    width: 48px !important;
    height: 48px !important;
    border-radius: 15px !important;
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08) !important;
  }

  .pv-app-switch-icon img {
    width: 34px !important;
    height: 34px !important;
    object-fit: contain !important;
    display: block !important;
  }

  .pv-app-switch-name {
    width: 100% !important;
    color: #0f172a !important;
    font-size: 12px !important;
    line-height: 1.25 !important;
    font-weight: 850 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .pv-app-active-dot {
    position: absolute !important;
    top: 9px !important;
    right: 9px !important;
    width: 8px !important;
    height: 8px !important;
    border-radius: 999px !important;
    background: #22c55e !important;
    box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.16) !important;
  }

  .pv-store-switch-popover {
    width: min(440px, calc(100vw - 48px)) !important;
    max-width: min(440px, calc(100vw - 48px)) !important;
  }

  .pv-store-switch-list {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
    max-height: min(420px, calc(100vh - 220px)) !important;
    overflow-y: auto !important;
    padding: 2px 4px 4px 2px !important;
    scrollbar-width: thin !important;
  }

  .pv-store-switch-list::-webkit-scrollbar {
    width: 7px;
  }

  .pv-store-switch-list::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #cbd5e1;
  }

  .pv-store-switch-item {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    width: 100% !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 14px !important;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;
    padding: 12px 14px !important;
    cursor: pointer !important;
    text-align: left !important;
    font-size: 13px !important;
    color: #0f172a !important;
    font-weight: 800 !important;
    transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease, background 0.16s ease !important;
  }

  .pv-store-switch-item:hover {
    transform: translateY(-1px) !important;
    border-color: #0d532f !important;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.10) !important;
    background: #ffffff !important;
  }

  .pv-store-switch-item.active {
    border-color: #0d532f !important;
    background: radial-gradient(circle at top, rgba(13, 83, 47, 0.10), transparent 55%), #ffffff !important;
    box-shadow: 0 10px 22px rgba(13, 83, 47, 0.12) !important;
  }

  .pv-store-switch-item.loading,
  .pv-store-switch-item.empty {
    cursor: default !important;
    justify-content: center !important;
    color: #64748b !important;
    font-weight: 700 !important;
  }

  .pv-store-switch-icon {
    width: 34px !important;
    height: 34px !important;
    flex-shrink: 0 !important;
    border-radius: 10px !important;
    background: #ecfdf5 !important;
    border: 1px solid #a7f3d0 !important;
    color: #0d532f !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .pv-store-switch-name {
    flex: 1 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  @keyframes pvSwitchBackdropIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes pvSwitchModalIn {
    from {
      opacity: 0;
      transform: translateY(10px) scale(0.985);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    .pv-app-switch-backdrop {
      align-items: flex-start !important;
      padding: 86px 14px 18px !important;
    }

    .pv-app-switch-popover {
      width: 100% !important;
      max-width: 100% !important;
      max-height: calc(100vh - 112px) !important;
      border-radius: 20px !important;
      padding: 14px !important;
    }

    .pv-app-switch-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      max-height: calc(100vh - 250px) !important;
    }

    .pv-app-switch-card {
      min-height: 96px !important;
    }
  }

  @media (max-width: 480px) {
    .pv-app-switch-head {
      flex-direction: column !important;
    }

    .pv-app-switch-head-actions {
      width: 100% !important;
      justify-content: space-between !important;
    }

    .pv-app-switch-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .pv-app-switch-card {
      min-height: 92px !important;
    }
  }
`;

export default Header;
